import React from 'react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import CountryCodeSelect from '../CountryCodeSelect';

const SDMobileContactForm = ({ formData, setFormData, errors, setErrors, countryCode, setCountryCode, countryCodes, detectedCountry, isLoading, handleSubmit, handleEmailBlur, handlePhoneChange, validateEmail }) => (
  <section className="md:hidden py-10 bg-gray-50" data-testid="mobile-contact-form-section">
    <div className="max-w-lg mx-auto px-4">
      <h2 className="text-2xl font-bold text-[#1A3628] text-center mb-2">Get Started Today</h2>
      <p className="text-sm text-gray-600 text-center mb-6">Fill out the form and our team will reach out to you shortly.</p>
      <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-lg p-6 space-y-4 border border-gray-100">
        <Input
          placeholder="Your Name"
          value={formData.name}
          onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
          required
          data-testid="mobile-form-name"
        />
        <div>
          <Input
            type="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={(e) => { setFormData(prev => ({ ...prev, email: e.target.value })); if (errors.email && validateEmail(e.target.value)) setErrors(prev => ({ ...prev, email: '' })); }}
            onBlur={handleEmailBlur}
            required
            data-testid="mobile-form-email"
          />
          {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
        </div>
        <div>
          <div className="flex gap-2">
            <CountryCodeSelect value={countryCode} onChange={setCountryCode} countryCodes={countryCodes} className="w-24" testId="mobile-form-country" />
            <Input
              type="tel"
              placeholder="Phone (e.g., 123-456-7890)"
              value={formData.phone}
              onChange={handlePhoneChange}
              required
              className="flex-1"
              data-testid="mobile-form-phone"
            />
          </div>
          {detectedCountry && <p className="text-xs text-gray-400 mt-1">Detected: {detectedCountry.countryName}</p>}
          {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
        </div>
        <Textarea
          placeholder="What are you looking to protect? (e.g. Name, Logo and Slogan)"
          value={formData.message}
          onChange={(e) => setFormData(prev => ({ ...prev, message: e.target.value }))}
          rows={3}
          data-testid="mobile-form-message"
        />
        <Button
          type="submit"
          disabled={isLoading}
          className="w-full bg-[#C85A40] hover:bg-[#A64730] text-white"
          data-testid="mobile-form-submit"
        >
          {isLoading ? 'Submitting...' : 'Submit Inquiry'}
        </Button>
      </form>
    </div>
  </section>
);

export default SDMobileContactForm;
